"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.betReducer = betReducer;
var _types = require("../bet/types");
var initialState = {
  betChangeAllowed: true,
  featureSet: 0
};
function betReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.UPDATE_BET:
      {
        var newState = Object.assign({}, state, action.payload);

        // This is to catch an edge case. should never happen really.
        // Due to bug with playergamestate this could occur, and this fixes it retroactively.
        if (newState.denomination <= 0) {
          newState.denomination = newState.denominations[0];
        }
        newState.coinValue = newState.coins * newState.lines;
        newState.value = newState.coins * newState.lines * newState.denomination;
        newState.centValue = newState.coins * newState.lines * newState.denomination * 100;
        return newState;
      }
    case _types.COINS_MINUS:
      {
        var nextCoins = state.coins > 1 ? state.coins - 1 : 1;
        var _newState = Object.assign({}, state, {
          coins: nextCoins
        });
        _newState.coinValue = _newState.coins * _newState.lines;
        _newState.value = _newState.coins * _newState.lines * _newState.denomination;
        _newState.centValue = _newState.coins * _newState.lines * _newState.denomination * 100;
        return _newState;
      }
    case _types.COINS_PLUS:
      {
        var _nextCoins = state.coins < state.maxCoins ? state.coins + 1 : state.maxCoins;
        var _newState2 = Object.assign({}, state, {
          coins: _nextCoins
        });
        _newState2.coinValue = _newState2.coins * _newState2.lines;
        _newState2.value = _newState2.coins * _newState2.lines * _newState2.denomination;
        _newState2.centValue = _newState2.coins * _newState2.lines * _newState2.denomination * 100;
        return _newState2;
      }
    case _types.UPDATE_FORMATTED_BET:
      {
        var _newState3 = Object.assign({}, state, {
          formatted: action.payload
        });
        _newState3.coinValue = _newState3.coins * _newState3.lines;
        _newState3.value = _newState3.coins * _newState3.lines * _newState3.denomination;
        _newState3.centValue = _newState3.coins * _newState3.lines * _newState3.denomination * 100;
        return _newState3;
      }
    case _types.SET_DEFAULT_BET:
      {
        var t = Object.assign(state, {
          defaultDenomination: action.payload.denomination
        });
        return t;
      }
    case _types.BET_CHANGE_DISABLE:
      {
        return Object.assign({}, state, {
          betChangeAllowed: false
        });
      }
    case _types.BET_CHANGE_ENABLE:
      {
        return Object.assign({}, state, {
          betChangeAllowed: true
        });
      }
    case _types.UPDATE_BET_FEATURE_SET:
      {
        return Object.assign({}, state, {
          featureSet: action.payload
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map